import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import classNames from "classname";
import BreadcrumbsData from "../variables/variables";

let ariaCurrent = "aria-current='page'";

const Breadcrumbs = (props) => {
  const router = useRouter();
  const [breadcrumbs, setBreadcrumbs] = useState(null);

  // PROPS VARIABLE
  let propsMiasto = props.miasto;
  let propsPodatek = props.podatek;

  let propsType;
  let extendedUrl = "";
  let siteCode = router.query.siteCode;

  if (BreadcrumbsData.miasta[propsMiasto].index) {
    propsType = "/";
  } else if (BreadcrumbsData.miasta[propsMiasto].witryna) {
    propsType = "/witryna/";
    extendedUrl = "?siteCode=" + siteCode;
  } else {
    propsType = "/" + BreadcrumbsData.miasta[propsMiasto].name.url + "/";
  }

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const replaceUnderscoresToSpace = (key) =>
    console.log(key.split("-").join(" "));
  // replaceUnderscoresToSpace("przyjazne-deklaracje-we-wroclawiu")

  const convertBreadcrumb = (string) => {
    const s = string.split("?")[0];

    const BreadcrumbText = {
      witryna: `Przyjazne Deklaracje ${BreadcrumbsData.miasta[propsMiasto].name.who}`,
      kontakt: "Kontakt",
      "mapa-strony": "Mapa strony",
      "deklaracja-dostepnosci": "Deklaracja dostępności",
      "podatek-od-srodkow-transportowych": "Podatek od środków transportowych",
      "podatek-od-nieruchomosci": "Podatek od nieruchomości",
      "podatek-rolny": "Podatek rolny",
      "podatek-lesny": "Podatek leśny",
      "oplata-za-gospodarowanie-odpadami-komunalnymi":
        "Opłata za gospodarowanie odpadami komunalnymi",
      "dla-mieszkanca": "Dla Mieszkańca",
      "dla-samorzadu": "Dla Samorządu",
      "abc-podatkow": "ABC podatków",
      "jak-to-dziala": "Jak to działa",
      "wazne-terminy": "Ważne terminy",
      aktualnosci: "Aktualności",
      wyszukiwarka: "Wyszukiwarka",
    };

    return (
      BreadcrumbText[s] ||
      `Przyjazne Deklaracje ${BreadcrumbsData.miasta[propsMiasto].name.who}`
    );
  };

  useEffect(() => {
    if (router) {
      const linkPath = router.asPath.split("/");
      linkPath.shift();

      const pathArray = linkPath.map((path, i) => {
        return {
          breadcrumb: path,
          href: "/" + linkPath.slice(0, i + 1).join("/"),
        };
      });

      setBreadcrumbs(pathArray);
    }
  }, [router]);

  if (!breadcrumbs) {
    return null;
  }

  return (
    <section
      className={classNames("pd-breadcrumbs", {
        "pd-breadcrumbs--light": props.layout === "light",
        "pd-breadcrumbs--dark": props.layout === "dark",
      })}
    >
      <nav aria-label="Breadcrumbs">
        <ul className="pd-breadcrumbs__list">
          {propsMiasto === "PRZYJAZNEDEKLARACJE" ? (
            <li>
              <a href="/" title="Przyjazne Deklaracje">
                Przyjazne Deklaracje
              </a>
            </li>
          ) : (
            <li>
              <a
                href={propsType + extendedUrl}
                title={
                  "Przyjazne Deklaracje " +
                  BreadcrumbsData.miasta[propsMiasto].name.who
                }
              >
                {"Przyjazne Deklaracje " +
                  BreadcrumbsData.miasta[propsMiasto].name.who}
              </a>
            </li>
          )}

          {breadcrumbs.map((breadcrumb, i) => {
            return (
              <>
                {(i >= 0) & (i < breadcrumbs.length - 1) ? (
                  <li key={i}>
                    <a
                      href={breadcrumb.href}
                      title={convertBreadcrumb(breadcrumb.breadcrumb)}
                    >
                      {convertBreadcrumb(breadcrumb.breadcrumb)}
                    </a>
                  </li>
                ) : null}

                {i === breadcrumbs.length - 1 && (
                  <li key={i}>
                    {props.title ? (
                      <span title={props.title}>{props.title}</span>
                    ) : (
                      <span title={convertBreadcrumb(breadcrumb.breadcrumb)}>
                        {convertBreadcrumb(breadcrumb.breadcrumb)}
                      </span>
                    )}
                  </li>
                )}
              </>
            );
          })}
        </ul>
      </nav>
    </section>
  );
};

export default Breadcrumbs;
